var map = {
	"./BurgerMenu.json": [
		1612
	],
	"./Controller.json": [
		6482,
		482
	],
	"./Fetus.json": [
		3305
	],
	"./Parentheses.json": [
		6342,
		342
	],
	"./Phone.json": [
		4506,
		506
	],
	"./WWW.json": [
		6701,
		701
	],
	"./Wrench.json": [
		5247,
		247
	],
	"./X.json": [
		8830
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7699;
module.exports = webpackAsyncContext;